// import React from 'react';
// import Button from '@mui/material/Button';
// import Snackbar from '@mui/material/Snackbar';
// // import { withStyles } from "@mui/material/styles";
// // import { withStyles } from "@mui/styles";
// import { makeStyles } from "@mui/styles";



// class  SnackBar extends React.Component{
//   render(){
//     return (       

//       <Snackbar
//       anchorOrigin={{
//         vertical: 'top',
//         horizontal: 'center',
//       }}
//       classes = {{
//         "root": "top-snackbar"
//       }}
//       variant="info"
//       autoHideDuration={2000}
//       open={this.props.open}
//       onClose={() => {this.props.handleSnackbarClose()}}
//       ContentProps={{
//         'aria-describedby': 'message-id',
//       }}
//       message={<span id="message-id">{this.props.message}</span>}
//       />  

//         );
//       }
      
// }

// export default makeStyles({
//   root: {
//     top: "8px"
//   }
// })(SnackBar)


// import React from "react";
// import Snackbar from "@mui/material/Snackbar";
// // import { makeStyles } from "@material-ui/core/styles";
//  import { makeStyles } from "@mui/styles";

// const useStyles = makeStyles({
//   root: {
//     top: "8px",
//   },
// });

// const SnackBar = ({ open, handleSnackbarClose, message }) => {
//   const classes = useStyles();

//   return (
//     <Snackbar
//       anchorOrigin={{
//         vertical: "top",
//         horizontal: "center",
//       }}
//       classes={{ root: classes.root }}
//       variant="info"
//       autoHideDuration={2000}
//       open={open}
//       onClose={handleSnackbarClose}
//       ContentProps={{
//         "aria-describedby": "message-id",
//       }}
//       message={<span id="message-id">{message}</span>}
//     />
//   );
// };

// export default SnackBar;



import React from "react";
import Snackbar from "@mui/material/Snackbar";
import { withStyles } from "@mui/styles"; // ✅ Use withStyles instead

const styles = {
  root: {
    top: "8px"
  }
};

class SnackBar extends React.Component {
  render() {
    const { classes } = this.props; // ✅ Access styles from props

    return (
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
        classes={{
          root: classes.root // ✅ Apply styles correctly
        }}
        variant="info"
        autoHideDuration={2000}
        open={this.props.open}
        onClose={() => {
          this.props.handleSnackbarClose();
        }}
        ContentProps={{
          "aria-describedby": "message-id"
        }}
        message={<span id="message-id">{this.props.message}</span>}
      />
    );
  }
}

export default withStyles(styles)(SnackBar); // ✅ Correct way to apply styles in a class component

